import { VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { messageType } from "@components/molecules/PopUp/types";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { VDBIcons } from "@utils/VDBIcons";
import React from "react";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";

const PopupTitleContainer = (props: any) => {
  const { type, PopUpIcon, title, borderRadius, onClose, showCloseButton } =
    props;
  const theme = useTheme();
  const typography = useTypographyStore();
  const handleCloseModal = () => {
    onClose?.();
  };
  return (
    <PopupHeader type={type} borderRadius={borderRadius}>
      {type !== messageType.Generic && (
        <IconFrame type={type}>
          <VDBIcon
            name={PopUpIcon}
            variant={IconsVariant.VDBCustom}
            size={24}
            color={theme["cont-00"]}
          />
        </IconFrame>
      )}
      <TitleTopContainer forGeneric={type === messageType.Generic}>
        <VDBText
          color={theme["core-05"]}
          type={
            type === messageType.Generic
              ? typography["H1-B"]
              : typography["H2-M"]
          }
        >
          {title}
        </VDBText>
      </TitleTopContainer>
      {showCloseButton && (
        <CloseButton onPress={handleCloseModal}>
          <VDBIcon
            name={VDBIcons.CLOSE_CIRCLE}
            variant={IconsVariant.VDBCustom}
            size={24}
            color={theme["core-06"]}
          />
        </CloseButton>
      )}
    </PopupHeader>
  );
};
const PopupHeader = styled.View<any>`
  width: 100%;
  padding-top: ${SpaceType.Big}px;
  padding-bottom: ${({ type }) => (type === messageType.Generic ? 0 : 24)}px;
  padding-left: ${SpaceType.Double}px;
  padding-right: ${SpaceType.Double}px;
  align-items: center;
  background-color: ${({ type, theme }) =>
    type === messageType.Error
      ? theme["error-02"]
      : type === messageType.Success
      ? theme["success-02"]
      : type === messageType.Warning
      ? theme["warn-02"]
      : theme["core-01"]};
  flex-direction: row;
  border-top-left-radius: ${({ borderRadius }) =>
    borderRadius ? borderRadius : 10}px;
  border-top-right-radius: ${({ borderRadius }) =>
    borderRadius ? borderRadius : 10}px;
`;
const IconFrame = styled.View<any>`
  border-radius: 40px;
  background-color: ${({ type, theme }) =>
    type === messageType.Error
      ? theme["error-01"]
      : type === messageType.Success
      ? theme["success-01"]
      : theme["warn-01"]};
  padding: 8px;
  margin-right: 8px;
  align-items: center;
`;
const TitleTopContainer = styled.View<{
  forGeneric: boolean;
}>`
  align-items: flex-start;
  padding-start: ${({ forGeneric }) => (forGeneric ? 0 : 8)}px;
  padding-end: ${({ forGeneric }) => (forGeneric ? 0 : 0)}px;
  flex: 1;
`;

const CloseButton = styled.TouchableOpacity`
  position: absolute;
  padding: ${SpaceType.Basic}px;
  right: 0;
  top: 0;
`;

export default PopupTitleContainer;
